import { USER_TOKEN } from '../constants/user';

export function userToken(userToken) {
  return {
    type: USER_TOKEN,
    payload: userToken,
  };
}
